import {
  AdvancedSearchComponentType,
  IframelyMedia,
  SearchParams,
} from '@prismamedia/one-components';
import { ArticleFormat } from '__generated__/queries-web';
import React from 'react';

export interface IndexRange {
  startIndex: number;
  stopIndex: number;
}

export type IframelyFn = (url: string) => Promise<IframelyMedia>;
export enum MEDIA_TYPES_LABEL {
  ARTICLES = 'ARTICLES',
  RECIPES = 'RECETTES',
  VIDEOS = 'VIDEOS',
  SLIDESHOWS = 'DIAPOS',
  PODCASTS = 'PODCASTS',
  IMAGES = 'PHOTOS',
}

export interface MediasWrapper {
  Component?: React.ComponentType<any>;
  Icon: React.ComponentType;
  badgeContent?: React.ReactNode;
  label: string;
  props?: Record<string, unknown>;
  type: MEDIA_TYPES_LABEL | string;
}

export type ItemType<I> = I & { id: string };

export enum ViewMode {
  GRID = 'GRID',
  GRID_HORIZONTAL = 'GRID_HORIZONTAL',
  LIST = 'LIST',
}

export type ItemSerialized = Record<string, any> & {
  id: string;
  pluginType: MEDIA_TYPES_LABEL;
};
// DEFAULT ITEM FORMAT (FOR RENDERING)

export interface ItemToRenderProps {
  brandKey?: string;
  id: string;
  image?: string;
  publicUrl?: string | null;
  publishDate?: string | null;
  site?: string;
  text?: string;
  title?: string | null;
  slideShowArticleCount?: number;
}

export interface MultimediaSearchPluginProps<Item = ItemToRenderProps> {
  allowMultiSelect?: boolean;
  allowSearch?: boolean;
  allowedMedias: MediasWrapper[];
  fetchMore?: (params: IndexRange) => Promise<ItemSerialized[]>;
  itemToIframely: (
    item: ItemSerialized,
    pluginType: string,
  ) => Promise<IframelyMedia>;
  itemToRender: (item: ItemSerialized, pluginType?: string) => Item;
  placeholder?: string;
  searchFn: (
    searchParams: SearchParams,
    opts: { first: number; skip: number },
    pluginType: string,
  ) => Promise<any[]>;
  suggestArticlesFn?: (format: ArticleFormat) => Promise<any[]>;
  viewMode?: ViewMode;
  advancedSearch?: AdvancedSearchComponentType;
  itemClickCallback?: (item: ItemSerialized) => void;
}
